import React from "react";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { COMPARISON } from "./data";

export default function WhyBreaks() {
  return (
    <section className="section section--why" id="why">
      <div className="wrap">
        <Reveal>
          <div className="sec-head">
            <span className="sec-kicker">Why it breaks</span>
            <h2 className="sec-title">What people think they have — versus what they actually need.</h2>
          </div>
        </Reveal>

        <div className="cmp" data-testid="comparison">
          <div className="cmp__heads">
            <span className="cmp__h cmp__h--muted">What people think they have</span>
            <span className="cmp__h cmp__h--need">What they actually need</span>
          </div>
          {COMPARISON.map((row, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div className="cmp__row" data-testid={"cmp-row-" + i}>
                <span className="cmp__think">{row.think}</span>
                <span className="cmp__arrow"><ArrowRight size={18} /></span>
                <span className="cmp__need">{row.need}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
